import { ExceptionsEnum } from '@commerce-cart-webcomponents/sdk';

export const FulfillmentExceptionMessageKey: Record<string, string> = {
  [ExceptionsEnum.Exceptions.FulfillmentService]: 'cart.cartTopSection.shippingException',
};
